import { FC } from 'react';
import { IScenarioDataModel } from '../../../../data-models/scenario.data-model';
import { AllocationBanner } from './AllocationBanner';
import { WeightedScenarioList } from './WeightedScenarioList';
import { useWeightedScenarios } from './useWeightedScenarios';

interface IWeightedScenariosProps {
  companyId: number;
  scenarios: IScenarioDataModel[]; // all scenarios — drives the allocation total + blend
  filteredScenarios: IScenarioDataModel[]; // search/owner-filtered subset shown in the table
  canEdit: boolean;
}

/**
 * Probability-weighted scenarios view (FD-2862), rendered only when `showWeightedScenarios` is on.
 * Owns the `useWeightedScenarios` hook so its auto-save / auto-compute effects never run when the
 * flag is off (the component isn't mounted).
 */
export const WeightedScenarios: FC<IWeightedScenariosProps> = ({
  companyId,
  scenarios,
  filteredScenarios,
  canEdit,
}) => {
  const weighted = useWeightedScenarios(companyId, scenarios);

  return (
    <>
      {canEdit && (
        <AllocationBanner
          allocationTotal={weighted.allocationTotal}
          allocationState={weighted.allocationState}
        />
      )}
      <WeightedScenarioList
        scenarios={filteredScenarios}
        weightedResult={weighted.weightedResult}
        onWeightChange={weighted.updateWeight}
        canEdit={canEdit}
      />
    </>
  );
};
